import { useCallback, useEffect, useState } from "react";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { FRONTOFFICE_API } from "../../../core/apis/frontoffice-apis";
import { SERVICES } from "../../../core/services/services";
import { UserTypes } from "../../constants";
import { HELPER } from "../../helper/helper";
import { CustomLoader } from "../custom-loader/custom-loader";
import { CustomTable } from "../custom-table/custom-table";

export function DebitMandateTokens({ reference, userType }) {
  const [viewIndex, setViewIndex] = useState(0);
  const [debitMandateTokens, setDebitMandateTokens] = useState([]);
  const [error, setError] = useState(null);

  const tableHeaders = [
    { label: "Name", value: "name" },
    {
      label: "Reference",
      value: "reference",
    },
    { label: "Status", value: "status" },
    { label: "Total Successful Debit Amount", value: "successfulDebitAmount" },
    { label: "Total Successful Debit Count", value: "successfulDebitCount" },
    { label: "Created On", value: "creationTime" },
    { label: "Expires On", value: "expiryTime" },
  ];

  const openAction = useCallback((e, action, isMobile) => {
    // eslint-disable-next-line default-case
    switch (action) {
      case "VIEW": {
        //   getSettlementDetails(e, isMobile);
        break;
      }
    }
  }, []);

  const getDebitMandateTokens = useCallback(() => {
    setViewIndex(0);
    setDebitMandateTokens([]);
    const url =
      userType === UserTypes.Frontoffice
        ? FRONTOFFICE_API.DEBIT_MANDATES
        : BACKOFFICE_API.DEBIT_MANDATES;

    SERVICES.MAKE_GET_REQUEST(`${url}/${reference}/tokens`)
      .then((data) => {
        const result = data?.result;
        if (result.length) {
          let arr = [];
          result.forEach((e) => {
            arr.push({
              ...e,
              actions: "CR",
              detailsFunction: openAction,
            });
          });
          setDebitMandateTokens(arr);
        }
        setError(null);
        setViewIndex(1);
      })
      .catch((error) => {
        setError(HELPER.PROCESS_ERROR(error));
        setViewIndex(1);
      });
  }, [openAction, reference, userType]);

  useEffect(() => {
    getDebitMandateTokens();
  }, [getDebitMandateTokens]);

  const renderView = () => {
    switch (viewIndex) {
      case 0:
        return <CustomLoader loadingText="Loading..." />;
      case 1:
        return (
          <CustomTable
            isReload={true}
            totalPages={1}
            // totalItems={totalItems}
            currentPage={1}
            emptyText={"No mandate tokens found!"}
            reload={getDebitMandateTokens}
            error={error}
            items={debitMandateTokens}
            headers={tableHeaders}
            hasPagination={false}
          />
        );
      default:
        break;
    }
  };

  return (
    <div className="p-my-5">
      {/* <CustomModal
          closeModal={closeModal}
          onHide={onHide}
          visible={visible}
          modalContent={modalContent}
        /> */}
      {renderView()}
    </div>
  );
}
